module.exports = __webpack_public_path__ + "img/badge-tm-fill.c7a0d694.svg";